import React, { useCallback, useEffect, useState } from 'react';
import {
  AppInput,
  AppInputNumber,
  AppRemixIcon,
  AppSingleSelect,
  AppNoInfo,
  AppNotificationAlert,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import Translator from '../../../../../../components/helpers/Translator';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';

export default function EuskotrenPenaltyRiskTab(props) {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const poLevel3 = useSelector((s) => s.currentPage?.plantObligationLevels?.level3);
  const permissions = useSelector((s) => s.module[moduleBridgeHex].permissions);
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex].userBridge,
  );
  const [initialValues, setInitialValues] = useState();

  // > LOAD DATA TAB
  const loadDataTab = useCallback(async () => {
    await axios
      .post(axiosPath('api_r_user_module_legalCompliance_euskotrenPenaltyRisk_tab'), {
        moduleBridgeHex,
        plantHex,
        plantObligationID,
      })
      .then(({ data }) => {
        setInitialValues(data);
      });
  }, [moduleBridgeHex, plantHex, plantObligationID]);

  useEffect(() => {
    loadDataTab();
  }, []);
  // < LOAD DATA TAB

  // > EDIT
  const handleEdit = async (values) => {
    await axios
      .post(
        axiosPath('api_r_user_module_legalCompliance_euskotrenPenaltyRisk_edit'),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          values,
        },
      )
      .then(({ data }) => {
        setInitialValues(data);
        AppNotificationAlert({
          title: 'Actualizado',
          message: 'Se han actualizado los riesgos correctamente',
          type: 'success',
          duration: 5000,
          position: 'top-right',
        });
      });
  };
  // < EDIT

  const getBackgroundColor = (value) => {
    let color = '#f8f9fa';

    if (value >= 0 && value <= 2) {
      color = '#28a745';
    } else if (value > 2 && value <= 3) {
      color = '#efb403';
    } else if (value > 3 && value <= 4) {
      color = '#d7690f';
    } else if (value > 4) {
      color = '#dc3545';
    }

    return color;
  };

  if (!initialValues) return <AppNoInfo minHeight={300} />;

  return (
    <EuskotrenPenaltyRiskTabContainer>
      <Formik
        initialValues={initialValues}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        onSubmit={handleEdit}
      >
        {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">
              <div className="border p-3 mt-3">
                <div className="h5 text-center font-weight-bold">
                  Procesos ESTRATÉGICOS
                </div>

                <div className="border p-3">
                  <div className="text-center font-weight-bold">
                    CONSEJO de ADMINISTRACIÓN
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.boardDirectorsActivityRisk}
                            onChange={(v) =>
                              setFieldValue('boardDirectorsActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.boardDirectorsRiskCulture}
                            onChange={(v) =>
                              setFieldValue('boardDirectorsRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.boardDirectorsBackground}
                            onChange={(v) =>
                              setFieldValue('boardDirectorsBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div style={{ marginTop: '31px' }}>
                        <AppInputNumber
                          title="Impacto reputacional"
                          value={values.boardDirectorsReputationalImpact}
                          onChange={(v) =>
                            setFieldValue('boardDirectorsReputationalImpact', v)
                          }
                          icon={<AppRemixIcon icon="hashtag" noVariants />}
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.boardDirectorsAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.boardDirectorsAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border p-3 mt-3">
                  <div className="text-center font-weight-bold">
                    DIRECCIÓN GENERAL
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.generalManagementActivityRisk}
                            onChange={(v) =>
                              setFieldValue('generalManagementActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.generalManagementRiskCulture}
                            onChange={(v) =>
                              setFieldValue('generalManagementRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.generalManagementBackground}
                            onChange={(v) =>
                              setFieldValue('generalManagementBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div style={{ marginTop: '31px' }}>
                        <AppInputNumber
                          title="Impacto reputacional"
                          value={values.generalManagementReputationalImpact}
                          onChange={(v) =>
                            setFieldValue('generalManagementReputationalImpact', v)
                          }
                          icon={<AppRemixIcon icon="hashtag" noVariants />}
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.generalManagementAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.generalManagementAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border p-3 mt-3">
                <div className="h5 text-center font-weight-bold">
                  Procesos OPERATIVOS
                </div>

                <div className="border p-3">
                  <div className="text-center font-weight-bold">OPERACIONES </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.operationsActivityRisk}
                            onChange={(v) =>
                              setFieldValue('operationsActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.operationsRiskCulture}
                            onChange={(v) =>
                              setFieldValue('operationsRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.operationsBackground}
                            onChange={(v) => setFieldValue('operationsBackground', v)}
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div style={{ marginTop: '31px' }}>
                        <AppInputNumber
                          title="Impacto reputacional"
                          value={values.operationsReputationalImpact}
                          onChange={(v) =>
                            setFieldValue('operationsReputationalImpact', v)
                          }
                          icon={<AppRemixIcon icon="hashtag" noVariants />}
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.operationsAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.operationsAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border p-3 mt-3">
                <div className="h5 text-center font-weight-bold">
                  Procesos TRANSVERSALES
                </div>

                <div className="border p-3">
                  <div className="text-center font-weight-bold">
                    ECONÓMICO-FINANCIERO
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.economicFinancialActivityRisk}
                            onChange={(v) =>
                              setFieldValue('economicFinancialActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.economicFinancialRiskCulture}
                            onChange={(v) =>
                              setFieldValue('economicFinancialRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.economicFinancialBackground}
                            onChange={(v) =>
                              setFieldValue('economicFinancialBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="text-center font-weight-bold">Impacto 25%</div>
                      <AppInputNumber
                        title="Impacto reputacional"
                        value={values.economicFinancialReputationalImpact}
                        onChange={(v) =>
                          setFieldValue('economicFinancialReputationalImpact', v)
                        }
                        icon={<AppRemixIcon icon="hashtag" noVariants />}
                      />
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.economicFinancialAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.economicFinancialAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border p-3 mt-3">
                  <div className="text-center font-weight-bold">RECURSOS HUMANOS</div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.humanResourcesActivityRisk}
                            onChange={(v) =>
                              setFieldValue('humanResourcesActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.humanResourcesRiskCulture}
                            onChange={(v) =>
                              setFieldValue('humanResourcesRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.humanResourcesBackground}
                            onChange={(v) =>
                              setFieldValue('humanResourcesBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="text-center font-weight-bold">Impacto 25%</div>
                      <AppInputNumber
                        title="Impacto reputacional"
                        value={values.humanResourcesReputationalImpact}
                        onChange={(v) =>
                          setFieldValue('humanResourcesReputationalImpact', v)
                        }
                        icon={<AppRemixIcon icon="hashtag" noVariants />}
                      />
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.humanResourcesAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.humanResourcesAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border p-3 mt-3">
                  <div className="text-center font-weight-bold">
                    SISTEMAS y DESARROLLO TECNOLÓGICO
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.systemsActivityRisk}
                            onChange={(v) => setFieldValue('systemsActivityRisk', v)}
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.systemsRiskCulture}
                            onChange={(v) => setFieldValue('systemsRiskCulture', v)}
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.systemsBackground}
                            onChange={(v) => setFieldValue('systemsBackground', v)}
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="text-center font-weight-bold">Impacto 25%</div>
                      <AppInputNumber
                        title="Impacto reputacional"
                        value={values.systemsReputationalImpact}
                        onChange={(v) =>
                          setFieldValue('systemsReputationalImpact', v)
                        }
                        icon={<AppRemixIcon icon="hashtag" noVariants />}
                      />
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.systemsAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.systemsAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border p-3 mt-3">
                  <div className="text-center font-weight-bold">
                    ASESORÍA JURÍDICA y CUMPLIMIENTO NORMATIVO
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.legalAdviceActivityRisk}
                            onChange={(v) =>
                              setFieldValue('legalAdviceActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.legalAdviceRiskCulture}
                            onChange={(v) =>
                              setFieldValue('legalAdviceRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.legalAdviceBackground}
                            onChange={(v) =>
                              setFieldValue('legalAdviceBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="text-center font-weight-bold">Impacto 25%</div>
                      <AppInputNumber
                        title="Impacto reputacional"
                        value={values.legalAdviceReputationalImpact}
                        onChange={(v) =>
                          setFieldValue('legalAdviceReputationalImpact', v)
                        }
                        icon={<AppRemixIcon icon="hashtag" noVariants />}
                      />
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.legalAdviceAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.legalAdviceAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border p-3 mt-3">
                  <div className="text-center font-weight-bold">
                    RESTO de PROCESOS TRANSVERSALES
                  </div>
                  <div className="row mt-2">
                    <div className="col-7">
                      <div className="row">
                        <div className="col-12">
                          <div className="text-center font-weight-bold">
                            Probabilidad 75%
                          </div>
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Riesgo por actividad 70%"
                            value={values.otherProcessesActivityRisk}
                            onChange={(v) =>
                              setFieldValue('otherProcessesActivityRisk', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Cultura del riesgo 15%"
                            value={values.otherProcessesRiskCulture}
                            onChange={(v) =>
                              setFieldValue('otherProcessesRiskCulture', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                        <div className="col-4">
                          <AppInputNumber
                            title="Antecedentes 15%"
                            value={values.otherProcessesBackground}
                            onChange={(v) =>
                              setFieldValue('otherProcessesBackground', v)
                            }
                            icon={<AppRemixIcon icon="hashtag" noVariants />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="text-center font-weight-bold">Impacto 25%</div>
                      <AppInputNumber
                        title="Impacto reputacional"
                        value={values.otherProcessesReputationalImpact}
                        onChange={(v) =>
                          setFieldValue('otherProcessesReputationalImpact', v)
                        }
                        icon={<AppRemixIcon icon="hashtag" noVariants />}
                      />
                    </div>
                    <div className="col-2">
                      <div
                        className="text-center text-white font-weight-bold"
                        style={{
                          backgroundColor: getBackgroundColor(
                            values.otherProcessesAverageRiskWeighting,
                          ),
                        }}
                      >
                        <div>Ponderación del Riesgo medio</div>
                        <div className="p-3">
                          {values.otherProcessesAverageRiskWeighting}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border mt-4">
                  <div className="p-3">
                    <div className="row">
                      <div className="col-2">
                        <AppInputNumber
                          title="Nivel de riesgo aceptable en la organización"
                          value={values.acceptableLevelOrganisation}
                          onChange={(v) =>
                            setFieldValue('acceptableLevelOrganisation', v)
                          }
                          icon={<AppRemixIcon icon="hashtag" noVariants />}
                        />
                      </div>
                    </div>

                    <div className="row mt-4 mb-5">
                      <div className="col-2">
                        <div
                          className="text-center text-white font-weight-bold"
                          style={{
                            backgroundColor: getBackgroundColor(
                              values.weightedAverageInherent,
                            ),
                          }}
                        >
                          <div>Ponderación del riesgo medio inherente</div>
                          <div className="p-3">{values.weightedAverageInherent}</div>
                        </div>
                      </div>

                      <div className="col-2">
                        <div
                          className="text-center text-white font-weight-bold"
                          style={{
                            backgroundColor: getBackgroundColor(
                              values.resultAbsoluteInherent,
                            ),
                          }}
                        >
                          <div>Resultado Riesgo inherente ABSOLUTO</div>
                          <div className="p-3">{values.resultAbsoluteInherent}</div>
                        </div>
                      </div>

                      <div className="col-2">
                        <div
                          className="text-center font-weight-bold"
                          style={{
                            backgroundColor: '#ede6e6',
                          }}
                        >
                          <div>Controles aplicables al riesgo inherente absoluto</div>
                          <div className="p-3">
                            {values?.controlsApplicableAbsoluteInherent?.join(', ')}
                          </div>
                        </div>
                      </div>

                      <div className="col-2">
                        <div
                          className="text-center font-weight-bold"
                          style={{
                            backgroundColor: '#ede6e6',
                          }}
                        >
                          <div>Eficacia de los controles aplicables</div>
                          <div className="p-3">
                            {values.effectivenessApplicableControls}
                          </div>
                        </div>
                      </div>

                      <div className="col-2">
                        <div
                          className="text-center font-weight-bold"
                          style={{
                            backgroundColor: '#ede6e6',
                          }}
                        >
                          <div>Niveles a reducir</div>
                          <div className="p-3">{values.levelsReduced}</div>
                        </div>
                      </div>

                      <div className="col-2">
                        <div
                          className="text-center text-white font-weight-bold"
                          style={{
                            backgroundColor: getBackgroundColor(
                              values.resultResidual,
                            ),
                          }}
                        >
                          <div>Resultado Riesgo Residual</div>
                          <div className="p-3">{values.resultResidual}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                position: 'absolute',
                right: '2.5rem',
                bottom: '2rem',
              }}
            >
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary mt-3"
              >
                Guardar cambios
              </button>
            </div>
          </form>
        )}
      </Formik>
    </EuskotrenPenaltyRiskTabContainer>
  );
}

const EuskotrenPenaltyRiskTabContainer = styled.div`
  height: 400px;
  overflow-y: auto;
`;
